/*
 * ******************************************************************
 * Copyright (c) 2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */
import { Component, Input } from "@angular/core";

// @formatter:off
@Component({
    standalone: false,
    selector: "icon-label",
    templateUrl: "./icon-label.component.html",
    styleUrls: ["./icon-label.component.scss"]
})
// @formatter:on
export class IconLabelComponent {

    @Input()
    public label: string;

    @Input()
    public icon: string;

    @Input()
    public iconSize: string = "xl";

}
